/** Значки провайдеров входа (упрощённые монограммы в фирменных цветах). */
import { t } from '../../i18n';

/** Монограмма — функция: у Яндекса она зависит от языка («Я» / «Y»), а модуль при смене языка не перевыполняется. */
const MARKS: Record<string, { bg: string; fg: string; text: () => string }> = {
  google: { bg: '#ffffff', fg: '#4285f4', text: () => 'G' },
  github: { bg: '#24292f', fg: '#ffffff', text: () => 'GH' },
  yandex: { bg: '#fc3f1d', fg: '#ffffff', text: () => t('auth.mark.yandex') },
  microsoft: { bg: '#2f2f2f', fg: '#ffffff', text: () => 'MS' },
  discord: { bg: '#5865f2', fg: '#ffffff', text: () => 'D' },
};

/** Название провайдера на текущем языке: сервер присылает «Яндекс», остальные названия не переводятся. */
export function providerTitle(p: { id: string; title: string }): string {
  return p.id === 'yandex' ? t('auth.provider.yandex') : p.title;
}

export function ProviderIcon({ id }: { id: string }) {
  const m = MARKS[id];
  const style = m ? { background: m.bg, color: m.fg } : { background: 'var(--surface-2)', color: 'var(--text)' };
  return (
    <span className="provider-icon" style={style} aria-hidden="true">
      {m ? m.text() : id.slice(0, 1).toUpperCase()}
    </span>
  );
}
